import { ITeam } from "../../../entities/team";

export const getTeamSearchValue = (item: ITeam): string => (
    [
        item.name,
        item.tgAccounts.map(tg => `${tg.title} ${tg.username}`).join(' '),
        item.coordinators.map(coordinator => coordinator.fullName).join(' ')
    ].join(' ')
)
